/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
import { isNullOrUndefined, closest, extend, EventHandler, setStyleAttribute } from '@syncfusion/ej2-base';
import { createElement, prepend, append, addClass, removeClass } from '@syncfusion/ej2-base';
import { DataManager, Query, Predicate } from '@syncfusion/ej2-data';
import { generate, getDateFromRecurrenceDateString } from '../../recurrence-editor/date-generator';
import * as util from '../base/util';
import * as cls from '../base/css-constant';
import * as event from '../base/constant';
/**
 * EventBase for appointment rendering
 */
export class EventBase {
    /**
     * Constructor for EventBase
     *
     * @param {Schedule} parent Accepts the schedule instance
     */
    constructor(parent) {
        this.slots = [];
        this.isDoubleTapped = false;
        this.parent = parent;
    }
    processData(events, timeZonePropChanged, oldTimezone) {
        const start = this.parent.activeView.startDate();
        const end = this.parent.activeView.endDate();
        const fields = this.parent.eventFields;
        let processed = [];
        let temp = 1;
        let generateID = false;
        const resourceCollection = this.parent.resourceBase ? this.parent.resourceBase.resourceCollection : [];
        if (events.length > 0 && isNullOrUndefined(events[0][fields.id])) {
            generateID = true;
        }
        for (let event of events) {
            if (generateID) {
                event[fields.id] = temp++;
            }
            event = this.updateEventDateTime(event);
            if (timeZonePropChanged) {
                this.processTimezoneChange(event, oldTimezone);
            }
            else if (!this.parent.isPrinting && !this.parent.uiStateValues.isPreventTimezone) {
                event = this.processTimezone(event);
            }
            for (let level = 0; level < resourceCollection.length; level++) {
                if (event[resourceCollection[parseInt(level.toString(), 10)].field] === null || event[resourceCollection[parseInt(level.toString(), 10)].field] === 0) {
                    event[resourceCollection[parseInt(level.toString(), 10)].field] = undefined;
                }
            }
            if (!isNullOrUndefined(event[fields.recurrenceRule]) && event[fields.recurrenceRule] === '') {
                event[fields.recurrenceRule] = null;
            }
            if (!isNullOrUndefined(event[fields.recurrenceRule]) && isNullOrUndefined(event[fields.recurrenceID]) &&
                !(this.parent.crudModule && this.parent.crudModule.crudObj.isCrudAction)) {
                processed = processed.concat(this.generateOccurrence(event, null, true));
            }
            else {
                if (this.parent.crudModule && this.parent.crudModule.crudObj.isCrudAction) {
                    if (!isNullOrUndefined(event[fields.recurrenceRule]) && isNullOrUndefined(event[fields.recurrenceID])) {
                        const recurrenceEvent = this.generateOccurrence(event, null, true);
                        for (const occurrence of recurrenceEvent) {
                            const app = this.parent.eventsProcessed.filter((data) => data[fields.startTime].getTime() - occurrence[fields.startTime].getTime() === 0 &&
                                data[fields.id] === occurrence[fields.id]);
                            occurrence.Guid = (app.length > 0) ? app[0].Guid : this.generateGuid();
                            processed.push(occurrence);
                        }
                    }
                    else {
                        const app = this.parent.eventsProcessed.filter((data) => data[this.parent.eventFields.id] === event[this.parent.eventFields.id]);
                        event.Guid = (app.length > 0) ? app[0].Guid : this.generateGuid();
                        processed.push(event);
                    }
                }
                else {
                    event.Guid = this.generateGuid();
                    processed.push(event);
                }
            }
        }
        this.parent.eventsProcessed = [];
        const eventData = processed.filter((data) => !data[this.parent.eventFields.isBlock]);
        this.parent.eventsProcessed = this.filterEvents(start, end, eventData);
        const blockData = processed.filter((data) => data[this.parent.eventFields.isBlock]);
        for (const eventObj of blockData) {
            if (eventObj[fields.isAllDay]) {
                const isDifferentDate = util.resetTime(new Date(eventObj[fields.startTime].getTime())) <
                    util.resetTime(new Date(eventObj[fields.endTime].getTime()));
                if (!isDifferentDate) {
                    eventObj[fields.startTime] = util.resetTime(eventObj[fields.startTime]);
                    eventObj[fields.endTime] = util.addDays(util.resetTime(eventObj[fields.endTime]), 1);
                }
            }
        }
        this.parent.blockProcessed = blockData;
        return eventData;
    }
    updateEventDateTime(eventData) {
        if (typeof eventData[this.parent.eventFields.startTime] === 'string') {
            eventData[this.parent.eventFields.startTime] = util.getDateFromString(eventData[this.parent.eventFields.startTime]);
        }
        if (typeof eventData[this.parent.eventFields.endTime] === 'string') {
            eventData[this.parent.eventFields.endTime] = util.getDateFromString(eventData[this.parent.eventFields.endTime]);
        }
        return eventData;
    }
    getProcessedEvents(eventCollection = this.parent.eventsData) {
        let processed = [];
        for (const event of eventCollection) {
            if (!isNullOrUndefined(event[this.parent.eventFields.recurrenceRule]) &&
                isNullOrUndefined(event[this.parent.eventFields.recurrenceID])) {
                processed = processed.concat(this.generateOccurrence(event));
            }
            else {
                processed.push(event);
            }
        }
        return processed;
    }
    timezonePropertyChange(oldTimezone) {
        const data = this.parent.eventsData.concat(this.parent.blockData);
        const processed = this.processData(data, true, oldTimezone);
        this.parent.notify(event.dataReady, { processedData: processed });
    }
    timezoneConvert(eventData) {
        const fields = this.parent.eventFields;
        eventData[fields.startTimezone] = eventData[fields.startTimezone] || eventData[fields.endTimezone];
        eventData[fields.endTimezone] = eventData[fields.endTimezone] || eventData[fields.startTimezone];
        if (this.parent.timezone) {
            const startTz = eventData[fields.startTimezone];
            const endTz = eventData[fields.endTimezone];
            eventData[fields.startTime] = this.parent.tzModule.convert(eventData[fields.startTime], this.parent.timezone, startTz);
            eventData[fields.endTime] = this.parent.tzModule.convert(eventData[fields.endTime], this.parent.timezone, endTz);
        }
    }
    processTimezoneChange(event, oldTimezone) {
        const fields = this.parent.eventFields;
        if (event[fields.isAllDay]) {
            return;
        }
        if (oldTimezone && this.parent.timezone) {
            event[fields.startTime] = this.parent.tzModule.convert(event[fields.startTime], oldTimezone, this.parent.timezone);
            event[fields.endTime] = this.parent.tzModule.convert(event[fields.endTime], oldTimezone, this.parent.timezone);
        }
        else if (!oldTimezone && this.parent.timezone) {
            event[fields.startTime] = this.parent.tzModule.add(event[fields.startTime], this.parent.timezone);
            event[fields.endTime] = this.parent.tzModule.add(event[fields.endTime], this.parent.timezone);
        }
        else if (oldTimezone && !this.parent.timezone) {
            event[fields.startTime] = this.parent.tzModule.remove(event[fields.startTime], oldTimezone);
            event[fields.endTime] = this.parent.tzModule.remove(event[fields.endTime], oldTimezone);
        }
    }
    processTimezone(event, isReverse = false) {
        const fields = this.parent.eventFields;
        if (event[fields.isAllDay]) {
            return event;
        }
        if (event[fields.startTimezone] || event[fields.endTimezone]) {
            const startTimezone = event[fields.startTimezone] || event[fields.endTimezone];
            const endTimezone = event[fields.endTimezone] || event[fields.startTimezone];
            if (isReverse) {
                if (this.parent.timezone) {
                    event[fields.startTime] = this.parent.tzModule.convert(event[fields.startTime], startTimezone, this.parent.timezone);
                    event[fields.endTime] = this.parent.tzModule.convert(event[fields.endTime], endTimezone, this.parent.timezone);
                    event[fields.startTime] = this.parent.tzModule.remove(event[fields.startTime], this.parent.timezone);
                    event[fields.endTime] = this.parent.tzModule.remove(event[fields.endTime], this.parent.timezone);
                }
                else {
                    event[fields.startTime] = this.parent.tzModule.remove(event[fields.startTime], startTimezone);
                    event[fields.endTime] = this.parent.tzModule.remove(event[fields.endTime], endTimezone);
                }
            }
            else {
                event[fields.startTime] = this.parent.tzModule.add(event[fields.startTime], startTimezone);
                event[fields.endTime] = this.parent.tzModule.add(event[fields.endTime], endTimezone);
                if (this.parent.timezone) {
                    event[fields.startTime] = this.parent.tzModule.convert(event[fields.startTime], startTimezone, this.parent.timezone);
                    event[fields.endTime] = this.parent.tzModule.convert(event[fields.endTime], endTimezone, this.parent.timezone);
                }
            }
        }
        else if (this.parent.timezone) {
            if (isReverse) {
                event[fields.startTime] = this.parent.tzModule.remove(event[fields.startTime], this.parent.timezone);
                event[fields.endTime] = this.parent.tzModule.remove(event[fields.endTime], this.parent.timezone);
            }
            else {
                event[fields.startTime] = this.parent.tzModule.add(event[fields.startTime], this.parent.timezone);
                event[fields.endTime] = this.parent.tzModule.add(event[fields.endTime], this.parent.timezone);
            }
        }
        return event;
    }
    filterBlockEvents(eventObj) {
        const fields = this.parent.eventFields;
        const eStart = eventObj[fields.startTime];
        const eEnd = eventObj[fields.endTime];
        let resourceData;
        if (this.parent.activeViewOptions.group.resources.length > 0) {
            const data = this.getGroupIndexFromEvent(eventObj);
            resourceData = this.parent.resourceBase.lastResourceLevel[parseInt(data.toString(), 10)];
        }
        const blockEvents = extend([], this.parent.blockProcessed, null, true);
        for (const eventObj of blockEvents) {
            if (eventObj[fields.isAllDay]) {
                const isDifferentTime = eventObj[fields.endTime].getTime() >
                    util.resetTime(new Date(eventObj[fields.endTime].getTime())).getTime();
                if (isDifferentTime) {
                    eventObj[fields.startTime] = util.resetTime(eventObj[fields.startTime]);
                    eventObj[fields.endTime] = util.addDays(util.resetTime(eventObj[fields.endTime]), 1);
                }
            }
        }
        return this.filterEvents(eStart, eEnd, blockEvents, resourceData);
    }
    filterEvents(startDate, endDate, appointments = this.parent.eventsProcessed, resourceTdData) {
        const predicate = this.parent.dataModule.getStartEndQuery(startDate, endDate);
        let filter = new DataManager({ json: appointments }).executeLocal(new Query().where(predicate));
        if (resourceTdData) {
            filter = this.filterEventsByResource(resourceTdData, filter);
        }
        return this.sortByTime(filter);
    }
    filterEventsByRange(eventCollection, startDate, endDate) {
        let filteredEvents = [];
        if (startDate && endDate) {
            filteredEvents = this.filterEvents(startDate, endDate, eventCollection);
        }
        else if (startDate && !endDate) {
            filteredEvents = eventCollection.filter((e) => e[this.parent.eventFields.startTime] >= startDate);
        }
        else if (!startDate && endDate) {
            filteredEvents = eventCollection.filter((e) => e[this.parent.eventFields.endTime] <= endDate);
        }
        else {
            filteredEvents = eventCollection;
        }
        return this.sortByTime(filteredEvents);
    }
    filterEventsByResource(resourceTdData, appointments = this.parent.eventsProcessed) {
        const predicate = {};
        const resourceCollection = this.parent.resourceBase.resourceCollection;
        for (let level = 0; level < resourceCollection.length; level++) {
            predicate[resourceCollection[parseInt(level.toString(), 10)].field] = resourceTdData.groupOrder[parseInt(level.toString(), 10)];
        }
        const keys = Object.keys(predicate);
        const filteredCollection = appointments.filter((eventObj) => keys.every((key) => {
            if (eventObj[`${key}`] instanceof Array) {
                return eventObj[`${key}`].indexOf(predicate[`${key}`]) > -1;
            }
            else {
                return eventObj[`${key}`] === predicate[`${key}`];
            }
        }));
        return filteredCollection;
    }
    sortByTime(appointmentsCollection) {
        if (this.parent.eventSettings.sortComparer && (typeof (this.parent.eventSettings.sortComparer) === 'function' || typeof (this.parent.eventSettings.sortComparer) === 'string')) {
            appointmentsCollection = this.customSorting(appointmentsCollection);
        }
        else {
            const fieldMappings = this.parent.eventFields;
            appointmentsCollection.sort((a, b) => {
                const d1 = a[fieldMappings.startTime];
                const d2 = b[fieldMappings.startTime];
                return d1.getTime() - d2.getTime();
            });
        }
        return appointmentsCollection;
    }
    sortByDateTime(appointments) {
        if (this.parent.eventSettings.sortComparer && (typeof (this.parent.eventSettings.sortComparer) === 'function' || typeof (this.parent.eventSettings.sortComparer) === 'string')) {
            appointments = this.customSorting(appointments);
        }
        else {
            const fieldMapping = this.parent.eventFields;
            appointments.sort((object1, object2) => {
                const d3 = object1[fieldMapping.startTime];
                const d4 = object2[fieldMapping.startTime];
                const d5 = object1[fieldMapping.endTime];
                const d6 = object2[fieldMapping.endTime];
                const d1 = d5.getTime() - d3.getTime();
                const d2 = d6.getTime() - d4.getTime();
                return (d3.getTime() - d4.getTime() || d2 - d1);
            });
        }
        return appointments;
    }
    customSorting(appointments) {
        if (typeof (this.parent.eventSettings.sortComparer) === 'function') {
            return this.parent.eventSettings.sortComparer.call(this.parent, appointments);
        }
        else if (typeof (this.parent.eventSettings.sortComparer) === 'string') {
            const splits = this.parent.eventSettings.sortComparer.split('.');
            let sortFn;
            if (!isNullOrUndefined(window)) {
                sortFn = window[splits[splits.length - 1]];
            }
            if (sortFn) {
                return sortFn(appointments);
            }
        }
        return appointments;
    }
    getSmallestMissingNumber(array) {
        const large = Math.max(...array);
        for (let i = 0; i < large; i++) {
            if (array.indexOf(i) === -1) {
                return i;
            }
        }
        return large + 1;
    }
    splitEventByDay(event) {
        const eventFields = this.parent.eventFields;
        const data = [];
        const eventStartTime = event[eventFields.startTime];
        const eventEndTime = event[eventFields.endTime];
        const isDifferentDate = util.resetTime(new Date(eventStartTime.getTime())) <
            util.resetTime(new Date(eventEndTime.getTime()));
        if (isDifferentDate) {
            let start = new Date(eventStartTime.getTime());
            let end = util.addDays(util.resetTime(new Date(eventStartTime.getTime())), 1);
            const endDate = (eventEndTime.getHours() === 0 && eventEndTime.getMinutes() === 0) ?
                eventEndTime : util.addDays(eventEndTime, 1);
            let index = 1;
            const eventLength = util.getDaysCount(eventStartTime.getTime(), endDate.getTime());
            while (end <= eventEndTime && start.getTime() !== end.getTime()) {
                const app = extend({}, event);
                app[eventFields.startTime] = start;
                app[eventFields.endTime] = end;
                app.data = { index: index, count: eventLength };
                app.Guid = this.generateGuid();
                app.isSpanned = true;
                data.push(app);
                start = end;
                if ((util.resetTime(new Date(start.getTime())).getTime() === util.resetTime(new Date(eventEndTime.getTime())).getTime())
                    && !(end.getTime() === eventEndTime.getTime())) {
                    end = new Date(start.getTime());
                    end = new Date(end.setHours(eventEndTime.getHours(), eventEndTime.getMinutes(), eventEndTime.getSeconds()));
                }
                else {
                    end = util.addDays(util.resetTime(new Date(start.getTime())), 1);
                }
                index++;
            }
        }
        else {
            data.push(event);
        }
        return data;
    }
    splitEvent(event, dateRender) {
        const fields = this.parent.eventFields;
        let start = util.resetTime(event[fields.startTime]).getTime();
        let end = util.resetTime(event[fields.endTime]).getTime();
        if (util.getDateInMs(event[fields.endTime]) <= 0) {
            const temp = util.addDays(util.resetTime(event[fields.endTime]), -1).getTime();
            end = start > temp ? start : temp;
        }
        const orgStart = start;
        const orgEnd = end;
        const ranges = [];
        if (start !== end) {
            if (start < dateRender[0].getTime()) {
                start = dateRender[0].getTime();
            }
            if (end > dateRender[dateRender.length - 1].getTime()) {
                end = dateRender[dateRender.length - 1].getTime();
            }
            let cStart = start;
            for (let level = 0; level < this.slots.length; level++) {
                let slot = this.slots[parseInt(level.toString(), 10)];
                if (this.parent.currentView === 'WorkWeek' || this.parent.currentView === 'TimelineWorkWeek'
                    || this.parent.activeViewOptions.group.byDate || this.parent.activeViewOptions.showWeekend) {
                    const slotDates = [];
                    for (const s of slot) {
                        slotDates.push(new Date(s));
                    }
                    const renderedDates = this.getRenderedDates(slotDates);
                    if (!isNullOrUndefined(renderedDates) && renderedDates.length > 0) {
                        slot = [];
                        for (const date of renderedDates) {
                            slot.push(date.getTime());
                        }
                    }
                }
                if (typeof (slot) === 'number') {
                    const temp = slot;
                    slot = [];
                    slot.push(temp);
                }
                const firstSlot = slot[0];
                cStart = (cStart <= firstSlot && end >= firstSlot) ? firstSlot : cStart;
                if (cStart > end || firstSlot > end) {
                    break;
                }
                if (!this.parent.activeViewOptions.group.byDate && this.parent.activeViewOptions.showWeekend &&
                    this.parent.currentView !== 'WorkWeek' && this.parent.currentView !== 'TimelineWorkWeek') {
                    const startIndex = slot.indexOf(cStart);
                    if (startIndex !== -1) {
                        let endIndex = slot.indexOf(end);
                        const hasBreak = endIndex !== -1;
                        endIndex = hasBreak ? endIndex : slot.length - 1;
                        const count = ((endIndex - startIndex) + 1);
                        const isLeft = (slot[parseInt(startIndex.toString(), 10)] !== orgStart);
                        const isRight = (slot[parseInt(endIndex.toString(), 10)] !== orgEnd);
                        ranges.push(this.cloneEventObject(event, slot[parseInt(startIndex.toString(), 10)], slot[parseInt(endIndex.toString(), 10)], count, isLeft, isRight));
                        if (hasBreak) {
                            break;
                        }
                    }
                }
                else {
                    if (this.dateInRange(cStart, slot[0], slot[slot.length - 1])) {
                        const availSlot = [];
                        for (let i = 0; i < slot.length; i++) {
                            if (this.dateInRange(slot[parseInt(i.toString(), 10)], orgStart, orgEnd)) {
                                availSlot.push(slot[parseInt(i.toString(), 10)]);
                            }
                        }
                        if (availSlot.length > 0) {
                            if (!this.parent.activeViewOptions.group.byDate) {
                                const isLeft = (availSlot[0] !== orgStart);
                                const isRight = (availSlot[availSlot.length - 1] !== orgEnd);
                                ranges.push(this.cloneEventObject(event, availSlot[0], availSlot[availSlot.length - 1], availSlot.length, isLeft, isRight));
                            }
                            else {
                                for (const slot of availSlot) {
                                    ranges.push(this.cloneEventObject(event, slot, slot, 1, (slot !== orgStart), (slot !== orgEnd)));
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            ranges.push(this.cloneEventObject(event, start, end, 1, false, false));
        }
        return ranges;
    }
    cloneEventObject(event, start, end, count, isLeft, isRight) {
        const fields = this.parent.eventFields;
        const e = extend({}, event, null, true);
        const data = { count: count, isLeft: isLeft, isRight: isRight };
        data[fields.startTime] = event[fields.startTime];
        data[fields.endTime] = event[fields.endTime];
        e.data = data;
        e[fields.startTime] = new Date(start);
        e[fields.endTime] = new Date(end);
        return e;
    }
    dateInRange(date, start, end) {
        return start <= date && date <= end;
    }
    getSelectedEventElements(target) {
        this.removeSelectedAppointmentClass();
        if (this.parent.selectedElements.length <= 0) {
            this.parent.selectedElements.push(target);
        }
        else {
            const isAlreadySelected = this.parent.selectedElements.filter((element) => element.getAttribute('data-guid') === target.getAttribute('data-guid'));
            if (isAlreadySelected.length <= 0) {
                const elementSelector = 'div[data-guid="' + target.getAttribute('data-guid') + '"]';
                const focusElements = [].slice.call(this.parent.element.querySelectorAll(elementSelector));
                for (const element of focusElements) {
                    this.parent.selectedElements.push(element);
                }
            }
            else {
                const selectedElements = this.parent.selectedElements.filter((element) => element.getAttribute('data-guid') !== target.getAttribute('data-guid'));
                this.parent.selectedElements = selectedElements;
            }
        }
        if (target && this.parent.selectedElements.length > 0) {
            this.addSelectedAppointments(this.parent.selectedElements, false);
        }
        return this.parent.selectedElements;
    }
    getSelectedEvents() {
        const eventSelect = [];
        const elementSelect = [];
        const selectAppointments = [].slice.call(this.parent.element.querySelectorAll('.' + cls.APPOINTMENT_BORDER));
        selectAppointments.filter((element) => {
            const isAlreadyAdded = eventSelect.filter((event) => {
                return event.Guid === element.getAttribute('data-guid');
            });
            if (isAlreadyAdded.length === 0) {
                eventSelect.push(this.getEventByGuid(element.getAttribute('data-guid')));
            }
            elementSelect.push(element);
        });
        return {
            event: eventSelect.length > 1 ? eventSelect : eventSelect[0],
            element: elementSelect.length > 1 ? elementSelect : elementSelect[0]
        };
    }
    removeSelectedAppointmentClass() {
        const selectedAppointments = this.getSelectedAppointments();
        removeClass(selectedAppointments, cls.APPOINTMENT_BORDER);
        if (this.parent.currentView === 'Agenda' || this.parent.currentView === 'MonthAgenda') {
            removeClass(selectedAppointments, cls.AGENDA_SELECTED_CELL);
        }
    }
    addSelectedAppointments(cells, preventFocus) {
        if (this.parent.currentView !== 'MonthAgenda') {
            this.parent.removeSelectedClass();
        }
        addClass(cells, cls.APPOINTMENT_BORDER);
        if (cells.length > 0 && !preventFocus) {
            cells[cells.length - 1].focus();
        }
    }
    getSelectedAppointments() {
        return [].slice.call(this.parent.element.querySelectorAll('.' + cls.APPOINTMENT_BORDER + ',.' + cls.APPOINTMENT_CLASS + ':focus'));
    }
    focusElement(isFocused) {
        if (this.parent.eventWindow.dialogObject && this.parent.eventWindow.dialogObject.visible) {
            return;
        }
        const activeEle = document.activeElement;
        const selectedCell = this.parent.getSelectedCells();
        if (selectedCell.length > 0 && ((activeEle && (this.parent.element.contains(activeEle) ||
            selectedCell.indexOf(activeEle) !== -1)) || isFocused)) {
            if (this.parent.keyboardInteractionModule) {
                const target = ((!isNullOrUndefined(this.parent.activeCellsData) &&
                    this.parent.activeCellsData.element) || selectedCell[selectedCell.length - 1]);
                this.parent.keyboardInteractionModule.selectCells(target instanceof Array, target);
            }
            return;
        }
        const selectedAppointments = this.getSelectedAppointments();
        if (selectedAppointments.length > 0) {
            if (this.parent.activeEventData && this.parent.activeEventData.element && selectedAppointments.indexOf(this.parent.activeEventData.element) > -1) {
                this.parent.activeEventData.element.focus();
                return;
            }
            selectedAppointments[selectedAppointments.length - 1].focus();
            return;
        }
    }
    selectWorkCellByTime(eventsData) {
        let target;
        if (this.parent.currentView === 'Agenda' || this.parent.currentView === 'MonthAgenda') {
            return target;
        }
        if (eventsData.length > 0) {
            const selectedObject = eventsData[eventsData.length - 1];
            const eventStartTime = selectedObject[this.parent.eventFields.startTime];
            let nearestTime;
            const isAllDay = this.isAllDayAppointment(selectedObject);
            if (this.parent.currentView === 'Month' || isAllDay || !this.parent.activeViewOptions.timeScale.enable) {
                nearestTime = new Date(+eventStartTime).setHours(0, 0, 0, 0);
            }
            else {
                nearestTime = this.findNearestSlot(eventStartTime);
            }
            let targetArea;
            if (isAllDay && ['Day', 'Week', 'WorkWeek'].indexOf(this.parent.currentView) !== -1) {
                targetArea = this.parent.getAllDayRow();
            }
            else {
                targetArea = this.parent.getContentTable();
            }
            let queryString = '[data-date="' + new Date(nearestTime).getTime() + '"]';
            if (!isNullOrUndefined(this.parent.activeViewOptions.group.resources) &&
                this.parent.activeViewOptions.group.resources.length > 0) {
                queryString += '[data-group-index="' + this.getGroupIndexFromEvent(selectedObject) + '"]';
            }
            target = targetArea.querySelector(queryString);
            if (target) {
                this.parent.activeCellsData = this.parent.getCellDetails(target);
                if (this.parent.keyboardInteractionModule) {
                    this.parent.keyboardInteractionModule.selectCells(false, target);
                }
                return target;
            }
        }
        return target;
    }
    findNearestSlot(appointmentTime) {
        const msMajorInterval = this.parent.activeViewOptions.timeScale.interval * util.MS_PER_MINUTE;
        const msInterval = msMajorInterval / this.parent.activeViewOptions.timeScale.slotCount;
        const numberOfSlots = Math.round(util.MS_PER_DAY / msInterval);
        const startTime = new Date(appointmentTime);
        startTime.setHours(0, 0, 0, 0);
        const slots = Array.from({ length: numberOfSlots }, (_, i) => {
            const slotTime = new Date(startTime.getTime() + i * msInterval);
            return slotTime;
        });
        const nearestSlot = slots.reduce((nearest, slot) => {
            const difference = Math.abs(appointmentTime.getTime() - slot.getTime());
            if (!nearest || difference < Math.abs(appointmentTime.getTime() - nearest.getTime())) {
                return slot;
            }
            return nearest;
        }, null);
        return Math.trunc(nearestSlot.getTime() / 1000) * 1000;
    }
    getGroupIndexFromEvent(eventData) {
        let levelIndex;
        let resource;
        let levelName;
        let idField;
        for (let i = this.parent.resourceBase.resourceCollection.length - 1; i >= 0; i--) {
            const resourceData = eventData[this.parent.resourceBase.resourceCollection[parseInt(i.toString(), 10)].field];
            if (!isNullOrUndefined(resourceData)) {
                resource = this.parent.resourceBase.resourceCollection[parseInt(i.toString(), 10)];
                levelIndex = i;
                levelName = resource.name;
                idField = resource.field;
                break;
            }
        }
        if (isNullOrUndefined(levelName) && isNullOrUndefined(levelIndex)) {
            levelName = this.parent.resourceCollection.slice(-1)[0].name;
            levelIndex = this.parent.resourceCollection.length - 1;
            idField = this.parent.resourceCollection.slice(-1)[0].field;
            resource = this.parent.resourceCollection.filter((e, index) => {
                if (e.name === levelName) {
                    levelIndex = index;
                    return e;
                }
                return null;
            })[0];
        }
        const id = ((eventData[`${idField}`] instanceof Array) ?
            eventData[`${idField}`][0] : eventData[`${idField}`]);
        if (levelIndex > 0) {
            const parentField = this.parent.resourceCollection[levelIndex - 1].field;
            return this.parent.resourceBase.getIndexFromResourceId(id, levelName, resource, eventData, parentField);
        }
        else {
            return this.parent.resourceBase.getIndexFromResourceId(id, levelName, resource);
        }
    }
    isAllDayAppointment(event) {
        const fieldMapping = this.parent.eventFields;
        const isAllDay = event[fieldMapping.isAllDay];
        const isFullDay = ((util.getUniversalTime(event[fieldMapping.endTime]) - util.getUniversalTime(event[fieldMapping.startTime]))
            / util.MS_PER_DAY) >= 1;
        return (isAllDay || (this.parent.eventSettings.spannedEventPlacement !== 'TimeSlot' && isFullDay)) ? true : false;
    }
    addEventListener() {
        this.parent.on(event.documentClick, this.appointmentBorderRemove, this);
    }
    removeEventListener() {
        this.parent.off(event.documentClick, this.appointmentBorderRemove);
    }
    appointmentBorderRemove(event) {
        const element = event.event.target;
        if (closest(element, '.' + cls.APPOINTMENT_CLASS)) {
            if (this.parent.currentView !== 'MonthAgenda') {
                this.parent.removeSelectedClass();
            }
        }
        else if (!closest(element, '.' + cls.POPUP_OPEN)) {
            if (this.parent.uiStateValues.isTapHold && closest(element, '.' + cls.WORK_CELLS_CLASS + ',.' + cls.ALLDAY_CELLS_CLASS)) {
                return;
            }
            this.parent.uiStateValues.isTapHold = false;
            this.removeSelectedAppointmentClass();
            this.parent.selectedElements = [];
        }
    }
    wireAppointmentEvents(element, event, isPreventCrud = false) {
        const isReadOnly = (!isNullOrUndefined(event)) ? event[this.parent.eventFields.isReadonly] : false;
        EventHandler.add(element, 'click', this.eventClick, this);
        if (!this.parent.isAdaptive && !this.parent.activeViewOptions.readonly && !isReadOnly) {
            EventHandler.add(element, 'touchend', this.eventTouchClick, this);
            EventHandler.add(element, 'dblclick', this.eventDoubleClick, this);
        }
        if (!this.parent.activeViewOptions.readonly && !isReadOnly && !isPreventCrud) {
            if (this.parent.resizeModule) {
                this.parent.resizeModule.wireResizeEvent(element);
            }
            if (this.parent.dragAndDropModule) {
                this.parent.dragAndDropModule.wireDragEvent(element);
            }
        }
    }
    eventTouchClick(e) {
        if (this.parent.uiStateValues.isTouchScroll || this.parent.uiStateValues.isTapHold || this.parent.uiStateValues.action) {
            this.parent.uiStateValues.isTouchScroll = this.parent.uiStateValues.isTapHold = false;
            return;
        }
        setTimeout(() => this.isDoubleTapped = false, 250);
        e.preventDefault();
        if (this.isDoubleTapped) {
            this.eventDoubleClick(e);
        }
        else if (!this.isDoubleTapped) {
            this.isDoubleTapped = true;
            this.eventClick(e);
        }
    }
    renderResizeHandler(element, spanEvent, isReadOnly) {
        if (!this.parent.resizeModule || !this.parent.allowResizing || this.parent.activeViewOptions.readonly || isReadOnly) {
            return;
        }
        for (const resizeEdge of Object.keys(spanEvent)) {
            const resizeHandler = createElement('div', { className: cls.EVENT_RESIZE_CLASS });
            switch (resizeEdge) {
                case 'isLeft':
                    if (!spanEvent.isLeft) {
                        resizeHandler.appendChild(createElement('div', { className: 'e-left-right-resize' }));
                        addClass([resizeHandler], this.parent.enableRtl ? cls.RIGHT_RESIZE_HANDLER : cls.LEFT_RESIZE_HANDLER);
                        prepend([resizeHandler], element);
                    }
                    break;
                case 'isRight':
                    if (!spanEvent.isRight) {
                        resizeHandler.appendChild(createElement('div', { className: 'e-left-right-resize' }));
                        addClass([resizeHandler], this.parent.enableRtl ? cls.LEFT_RESIZE_HANDLER : cls.RIGHT_RESIZE_HANDLER);
                        append([resizeHandler], element);
                    }
                    break;
                case 'isTop':
                    if (!spanEvent.isTop) {
                        resizeHandler.appendChild(createElement('div', { className: 'e-top-bottom-resize' }));
                        addClass([resizeHandler], cls.TOP_RESIZE_HANDLER);
                        prepend([resizeHandler], element);
                    }
                    break;
                case 'isBottom':
                    if (!spanEvent.isBottom) {
                        resizeHandler.appendChild(createElement('div', { className: 'e-top-bottom-resize' }));
                        addClass([resizeHandler], cls.BOTTOM_RESIZE_HANDLER);
                        append([resizeHandler], element);
                    }
                    break;
            }
        }
    }
    eventClick(eventData) {
        const target = eventData.target;
        if (target.classList.contains(cls.DRAG_CLONE_CLASS) || target.classList.contains(cls.RESIZE_CLONE_CLASS) ||
            target.classList.contains(cls.INLINE_SUBJECT_CLASS)) {
            return;
        }
        if ((eventData.ctrlKey || eventData.metaKey) && eventData.which === 1 && this.parent.keyboardInteractionModule) {
            this.parent.quickPopup.quickPopup.hide();
            this.parent.selectedElements = [].slice.call(this.parent.element.querySelectorAll('.' + cls.APPOINTMENT_BORDER));
            const target = closest(eventData.target, '.' + cls.APPOINTMENT_CLASS);
            this.getSelectedEventElements(target);
            this.activeEventData(eventData, false);
            const selectArgs = {
                data: this.parent.activeEventData.event,
                element: this.parent.activeEventData.element,
                event: eventData, requestType: 'eventSelect'
            };
            this.parent.trigger(event.select, selectArgs);
            const args = extend(this.parent.activeEventData, { cancel: false, originalEvent: eventData });
            this.parent.trigger(event.eventClick, args);
        }
        else {
            this.removeSelectedAppointmentClass();
            this.activeEventData(eventData, true);
            const selectEventArgs = {
                data: this.parent.activeEventData.event,
                element: this.parent.activeEventData.element,
                event: eventData, requestType: 'eventSelect'
            };
            this.parent.trigger(event.select, selectEventArgs);
            const args = extend(this.parent.activeEventData, { cancel: false, originalEvent: eventData });
            this.parent.trigger(event.eventClick, args, (eventClickArgs) => {
                if (eventClickArgs.cancel) {
                    this.removeSelectedAppointmentClass();
                    this.parent.selectedElements = [];
                    if (this.parent.quickPopup) {
                        this.parent.quickPopup.quickPopupHide();
                    }
                }
                else {
                    if (this.parent.currentView === 'Agenda' || this.parent.currentView === 'MonthAgenda') {
                        addClass([this.parent.activeEventData.element], cls.AGENDA_SELECTED_CELL);
                    }
                    if (this.parent.allowInline) {
                        const inlineArgs = {
                            data: eventClickArgs.event,
                            element: eventClickArgs.element,
                            type: 'Event'
                        };
                        this.parent.notify(event.inlineClick, inlineArgs);
                    }
                    else {
                        this.parent.notify(event.eventClick, eventClickArgs);
                    }
                }
            });
        }
    }
    eventDoubleClick(eventData) {
        if (this.parent.quickPopup) {
            this.parent.quickPopup.quickPopupHide(true);
        }
        if (eventData.type === 'touchend') {
            this.activeEventData(eventData, true);
        }
        this.removeSelectedAppointmentClass();
        this.parent.selectedElements = [];
        if (this.parent.activeEventData.element.classList.contains(cls.INLINE_APPOINTMENT_CLASS) ||
            this.parent.activeEventData.element.querySelector('.' + cls.INLINE_SUBJECT_CLASS)) {
            return;
        }
        const args = extend(this.parent.activeEventData, { cancel: false, originalEvent: eventData });
        this.parent.trigger(event.eventDoubleClick, args, (eventDoubleClickArgs) => {
            if (!eventDoubleClickArgs.cancel) {
                if (!isNullOrUndefined(this.parent.activeEventData.event) &&
                    isNullOrUndefined(this.parent.activeEventData.event[this.parent.eventFields.recurrenceID])) {
                    this.parent.eventWindow.openEditor(this.parent.activeEventData.event, 'Save');
                }
                else {
                    this.parent.currentAction = 'EditOccurrence';
                    this.parent.quickPopup.openRecurrenceAlert();
                }
            }
        });
    }
    getEventByGuid(guid) {
        return this.parent.eventsProcessed.filter((data) => data.Guid === guid)[0];
    }
    getEventById(id) {
        return this.parent.eventsData.filter((data) => data[this.parent.eventFields.id] === id)[0];
    }
    generateGuid() {
        return 'xyxxxxyx-xxxy-yxxx-xyxx-xxyxxxxyyxxx'.replace(/[xy]/g, (c) => {
            const r = Math.random() * 16 | 0;
            const v = (c === 'x') ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    getEventIDType() {
        if (this.parent.eventsData.length !== 0) {
            return typeof (this.parent.eventsData[0][this.parent.eventFields.id]);
        }
        if (this.parent.blockData.length !== 0) {
            return typeof (this.parent.blockData[0][this.parent.eventFields.id]);
        }
        return 'string';
    }
    getEventMaxID(resourceId) {
        if (this.parent.eventsData.length < 1 && this.parent.blockData.length < 1) {
            return 1;
        }
        let eventId;
        const idType = this.getEventIDType();
        if (idType === 'string') {
            eventId = this.generateGuid();
        }
        if (idType === 'number') {
            const datas = this.parent.eventsData.concat(this.parent.blockData);
            const appIds = datas.map((event) => event[this.parent.eventFields.id]);
            let maxId = appIds.reduce((a, b) => Math.max(a, b));
            maxId = isNullOrUndefined(resourceId) ? maxId : maxId + resourceId;
            eventId = maxId + 1;
        }
        return eventId;
    }
    activeEventData(eventData, isMultiple) {
        const target = closest(eventData.target, '.' + cls.APPOINTMENT_CLASS);
        const guid = target.getAttribute('data-guid');
        if (isMultiple) {
            this.addSelectedAppointments([].slice.call(this.parent.element.querySelectorAll('div[data-guid="' + guid + '"]')), true);
            target.focus();
        }
        let eventObject = this.getEventByGuid(guid);
        if (eventObject && eventObject.isSpanned) {
            eventObject = this.parent.eventsData.filter((obj) => obj[this.parent.eventFields.id] === eventObject[this.parent.eventFields.id])[0];
        }
        this.parent.activeEventData = { event: eventObject, element: target };
    }
    generateOccurrence(event, viewDate, isMaxCount) {
        let startDate = event[this.parent.eventFields.startTime];
        const endDate = event[this.parent.eventFields.endTime];
        const eventRule = event[this.parent.eventFields.recurrenceRule];
        const timeZoneDiff = endDate.getTimezoneOffset() - startDate.getTimezoneOffset();
        const duration = (endDate.getTime() - startDate.getTime()) - (timeZoneDiff * 60000);
        viewDate = new Date((viewDate || this.parent.activeView.startDate()).getTime() - duration);
        const exception = event[this.parent.eventFields.recurrenceException];
        let maxCount;
        if (this.parent.currentView !== 'Agenda' && isMaxCount) {
            maxCount = util.getDateCount(viewDate, this.parent.activeView.endDate()) + 1;
        }
        const newTimezone = this.parent.timezone || this.parent.tzModule.getLocalTimezoneName();
        const firstDay = this.parent.activeViewOptions.firstDayOfWeek;
        const calendarMode = this.parent.calendarMode;
        if (event[this.parent.eventFields.recurrenceRule] && this.isDayBasedRecurrence(event) &&
            this.parent.timezone && event[this.parent.eventFields.startTimezone] && event[this.parent.eventFields.endTimezone]) {
            startDate = this.parent.tzModule.convert(event[this.parent.eventFields.startTime], this.parent.timezone, event[this.parent.eventFields.startTimezone]);
        }
        const dates = generate(startDate, eventRule, exception, firstDay, maxCount, viewDate, calendarMode, newTimezone);
        if (this.parent.currentView === 'Agenda' && eventRule.indexOf('COUNT') === -1 && eventRule.indexOf('UNTIL') === -1) {
            if (isNullOrUndefined(event.generatedDates)) {
                event.generatedDates = { start: new Date(dates[0]), end: new Date(dates[dates.length - 1]) };
            }
            else {
                if (dates[0] < event.generatedDates.start.getTime()) {
                    event.generatedDates.start = new Date(dates[0]);
                }
                if (dates[dates.length - 1] > event.generatedDates.end.getTime()) {
                    event.generatedDates.end = new Date(dates[dates.length - 1]);
                }
            }
        }
        let isDSTAdjusted = false;
        let convertedDates = [];
        if (event[this.parent.eventFields.recurrenceRule] && this.isDayBasedRecurrence(event) &&
            this.parent.timezone && event[this.parent.eventFields.startTimezone] && event[this.parent.eventFields.endTimezone]) {
            isDSTAdjusted = true;
            convertedDates.push(...dates.map((date) => this.parent.tzModule.convert(new Date(date), event[this.parent.eventFields.startTimezone], this.parent.timezone).getTime()));
        }
        convertedDates = convertedDates.length > 0 ? convertedDates : dates;
        const occurrenceCollection = [];
        for (let date of convertedDates) {
            const clonedObject = extend({}, event, null, true);
            date = !isDSTAdjusted ? this.getDSTAdjustedTime(date, clonedObject) : date;
            clonedObject[this.parent.eventFields.startTime] = new Date(date);
            clonedObject[this.parent.eventFields.endTime] = new Date(new Date(date).setMilliseconds(duration));
            clonedObject[this.parent.eventFields.recurrenceID] = clonedObject[this.parent.eventFields.id];
            delete clonedObject[this.parent.eventFields.recurrenceException];
            delete clonedObject[this.parent.eventFields.followingID];
            clonedObject.Guid = this.generateGuid();
            occurrenceCollection.push(clonedObject);
        }
        return occurrenceCollection;
    }
    isDayBasedRecurrence(event) {
        return (event[this.parent.eventFields.recurrenceRule].includes('BYMONTHDAY')
            || event[this.parent.eventFields.recurrenceRule].includes('BYDAY'));
    }
    getDSTAdjustedTime(date, event) {
        let occurDate = date;
        if (this.parent.timezone &&
            (event[this.parent.eventFields.startTimezone] || event[this.parent.eventFields.endTimezone])) {
            const eventOffset = this.getDSTDiff(event[this.parent.eventFields.startTime], new Date(date), event[this.parent.eventFields.startTimezone]);
            const schOffset = this.getDSTDiff(event[this.parent.eventFields.startTime], new Date(date), this.parent.timezone);
            occurDate = (new Date(date).getTime() - (eventOffset - schOffset) * 60000);
        }
        return occurDate;
    }
    getDSTDiff(startDate, occurDate, timezone) {
        const startOffset = this.parent.tzModule.offset(new Date(startDate), timezone);
        const occurOffset = this.parent.tzModule.offset(new Date(occurDate), timezone);
        return startOffset - occurOffset;
    }
    getParentEvent(eventObj, isParent = false) {
        let parentEvent;
        do {
            eventObj = this.getFollowingEvent(eventObj);
            if (eventObj) {
                parentEvent = extend({}, eventObj, null, true);
            }
        } while (eventObj && isParent);
        if (isParent && parentEvent) {
            const collection = this.getEventCollections(parentEvent);
            let followObj = collection.follow.slice(-1)[0];
            if (collection.occurrence.length > 0 && !parentEvent[this.parent.eventFields.recurrenceException]) {
                followObj = collection.occurrence.slice(-1)[0];
            }
            if (followObj) {
                parentEvent[this.parent.eventFields.recurrenceRule] = followObj[this.parent.eventFields.recurrenceRule];
            }
        }
        return parentEvent;
    }
    getEventCollections(parentObj, childObj) {
        const followingCollection = [];
        let occurrenceCollection = [];
        let followingEvent = parentObj;
        do {
            followingEvent = this.getFollowingEvent(followingEvent, true);
            if (followingEvent) {
                followingCollection.push(followingEvent);
            }
            occurrenceCollection = occurrenceCollection.concat(this.getOccurrenceEvent(followingEvent || parentObj));
        } while (followingEvent);
        let collections = {};
        if (childObj) {
            const fields = this.parent.eventFields;
            collections = {
                follow: followingCollection.filter((eventData) => eventData[fields.startTime] >= childObj[fields.startTime]),
                occurrence: occurrenceCollection.filter((eventData) => eventData[fields.startTime] >= childObj[fields.startTime])
            };
        }
        else {
            collections = { follow: followingCollection, occurrence: occurrenceCollection };
        }
        return collections;
    }
    getFollowingEvent(parentObj, isReverse) {
        const fields = this.parent.eventFields;
        let fieldValue;
        if (isReverse) {
            fieldValue = parentObj[fields.id];
        }
        else {
            fieldValue = (parentObj[fields.recurrenceID] || parentObj[fields.followingID]);
        }
        const parentApp = this.parent.eventsData.filter((data) => data[isReverse ? fields.followingID : fields.id] === fieldValue);
        return parentApp.shift();
    }
    isFollowingEvent(parentObj, childObj) {
        const parentStart = parentObj[this.parent.eventFields.startTime];
        const childStart = childObj[this.parent.eventFields.startTime];
        return parentStart.getHours() === childStart.getHours() && parentStart.getMinutes() === childStart.getMinutes() &&
            parentStart.getSeconds() === childStart.getSeconds();
    }
    getOccurrenceEvent(eventObj, isGuid = false, isFollowing = false) {
        const idField = isGuid ? 'Guid' : (isFollowing) ? this.parent.eventFields.followingID : this.parent.eventFields.recurrenceID;
        const fieldKey = isGuid ? 'Guid' : this.parent.eventFields.id;
        const dataSource = isGuid ? this.parent.eventsProcessed : this.parent.eventsData;
        return dataSource.filter((data) => data[`${idField}`] === eventObj[`${fieldKey}`]);
    }
    getOccurrencesByID(id) {
        const fields = this.parent.eventFields;
        let occurrenceCollection = [];
        const parentObject = this.parent.eventsData.filter((obj) => obj[fields.id] === id);
        for (const event of parentObject) {
            if (!isNullOrUndefined(event[fields.recurrenceRule])) {
                occurrenceCollection = occurrenceCollection.concat(this.generateOccurrence(event));
            }
        }
        return occurrenceCollection;
    }
    getOccurrencesByRange(startTime, endTime) {
        const fields = this.parent.eventFields;
        let occurrenceCollection = [];
        for (const event of this.parent.eventsData) {
            if (!isNullOrUndefined(event[fields.recurrenceRule])) {
                occurrenceCollection = occurrenceCollection.concat(this.generateOccurrence(event));
            }
        }
        const filter = occurrenceCollection.filter((obj) => obj[fields.startTime] >= startTime && obj[fields.endTime] <= endTime && !isNullOrUndefined(obj[fields.recurrenceID]));
        return filter;
    }
    getDeletedOccurrences(recurrenceData) {
        const fields = this.parent.eventFields;
        let parentObject;
        const deletedOccurrences = [];
        if (typeof recurrenceData === 'string' || typeof recurrenceData === 'number') {
            parentObject = this.parent.eventsData.filter((obj) => obj[fields.id] === recurrenceData)[0];
        }
        else {
            parentObject = extend({}, recurrenceData, null, true);
        }
        if (parentObject[fields.recurrenceException]) {
            const exDateString = parentObject[fields.recurrenceException].split(',');
            for (let i = 0, len = exDateString.length; i < len; i++) {
                const edited = this.parent.eventsData.filter((eventObj) => eventObj[fields.recurrenceID] === parentObject[fields.id] && eventObj[fields.recurrenceException] === exDateString[parseInt(i.toString(), 10)]);
                if (edited.length === 0) {
                    const exDate = getDateFromRecurrenceDateString(exDateString[parseInt(i.toString(), 10)]);
                    const childObject = extend({}, recurrenceData, null, true);
                    childObject[fields.recurrenceID] = parentObject[fields.id];
                    delete childObject[fields.followingID];
                    childObject[fields.recurrenceException] = exDateString[parseInt(i.toString(), 10)];
                    const startDate = new Date(exDate.getTime());
                    const time = parentObject[fields.endTime].getTime() - parentObject[fields.startTime].getTime();
                    const endDate = new Date(startDate.getTime());
                    endDate.setMilliseconds(time);
                    childObject[fields.startTime] = new Date(startDate.getTime());
                    childObject[fields.endTime] = new Date(endDate.getTime());
                    deletedOccurrences.push(childObject);
                }
            }
        }
        return deletedOccurrences;
    }
    applyResourceColor(element, data, type, index, alpha) {
        if (!this.parent.resourceBase) {
            return;
        }
        const alphaColor = (color, alpha) => {
            color = color.replace('#', '');
            const r = parseInt(color.substring(0, color.length / 3), 16);
            const g = parseInt(color.substring(color.length / 3, 2 * color.length / 3), 16);
            const b = parseInt(color.substring(2 * color.length / 3, 3 * color.length / 3), 16);
            return `rgba(${r}, ${g}, ${b}, ${alpha})`;
        };
        // index refers groupOrder
        const color = this.parent.resourceBase.getResourceColor(data, index);
        if (color) {
            element.style[type] = !isNullOrUndefined(alpha) ? alphaColor(color, alpha) : color;
        }
    }
    createBlockAppointmentElement(record, resIndex, isResourceEventTemplate) {
        const eventSubject = (record[this.parent.eventFields.subject] || this.parent.eventSettings.fields.subject.default);
        const appointmentWrapper = createElement('div', {
            className: cls.BLOCK_APPOINTMENT_CLASS,
            attrs: {
                'data-id': 'Appointment_' + record[this.parent.eventFields.id],
                'aria-disabled': 'true'
            }
        });
        let templateElement;
        if (!isNullOrUndefined(this.parent.activeViewOptions.eventTemplate)) {
            const scheduleId = this.parent.element.id + '_';
            const viewName = this.parent.activeViewOptions.eventTemplateName;
            const templateId = scheduleId + viewName + 'eventTemplate';
            const templateName = isResourceEventTemplate && this.parent.currentView.indexOf('Year') === -1 ?
                this.parent.getEventTemplateName(resIndex) : 'eventTemplate';
            templateElement = this.parent.getAppointmentTemplate()(record, this.parent, templateName, templateId, false, undefined, undefined, this.parent.root);
        }
        else {
            const appointmentSubject = createElement('div', { className: cls.SUBJECT_CLASS });
            this.parent.sanitize(eventSubject, appointmentSubject);
            templateElement = [appointmentSubject];
        }
        append(templateElement, appointmentWrapper);
        this.setWrapperAttributes(appointmentWrapper, resIndex);
        return appointmentWrapper;
    }
    setWrapperAttributes(appointmentWrapper, resIndex) {
        if (!isNullOrUndefined(this.cssClass)) {
            addClass([appointmentWrapper], this.cssClass);
        }
        if (this.parent.activeViewOptions.group.resources.length > 0) {
            appointmentWrapper.setAttribute('data-group-index', resIndex.toString());
        }
    }
    getReadonlyAttribute(event) {
        return (event[this.parent.eventFields.isReadonly] || this.parent.readonly).toString();
    }
    isBlockRange(eventData) {
        const eventCollection = (eventData instanceof Array) ? eventData : [eventData];
        let isBlockAlert = false;
        const fields = this.parent.eventFields;
        for (const event of eventCollection) {
            let dataCol = [];
            if (!isNullOrUndefined(event[fields.recurrenceRule]) &&
                (isNullOrUndefined(event[fields.recurrenceID]) || event[fields.id] === event[fields.recurrenceID])) {
                dataCol = this.generateOccurrence(event);
            }
            else {
                dataCol.push(event);
            }
            for (const data of dataCol) {
                const filterBlockEvents = this.filterBlockEvents(data);
                if (filterBlockEvents.length > 0) {
                    isBlockAlert = true;
                    break;
                }
            }
        }
        this.parent.uiStateValues.isBlock = isBlockAlert;
        return isBlockAlert;
    }
    getFilterEventsList(dataSource, query) {
        return new DataManager(dataSource).executeLocal(new Query().where(query));
    }
    getSeriesEvents(parentEvent, startTime) {
        const fields = this.parent.eventFields;
        startTime = isNullOrUndefined(startTime) ? parentEvent[fields.startTime] : startTime;
        let deleteFutureEditEvents;
        let futureEvents;
        const deleteFutureEditEventList = [];
        let delId = parentEvent[fields.id];
        let followingId = parentEvent[fields.followingID];
        let deleteFutureEvent;
        const startTimeQuery = this.parent.currentAction === 'EditSeries' ? 'greaterthan' : 'greaterthanorequal';
        do {
            deleteFutureEvent = ((new Predicate(fields.followingID, 'equal', delId))).
                and(new Predicate(fields.startTime, startTimeQuery, startTime));
            futureEvents = this.getFilterEventsList(this.parent.eventsData, deleteFutureEvent);
            deleteFutureEditEvents = futureEvents.slice(-1)[0];
            if (!isNullOrUndefined(deleteFutureEditEvents) && deleteFutureEditEvents[fields.id] !== followingId) {
                deleteFutureEditEventList.push(deleteFutureEditEvents);
                delId = deleteFutureEditEvents[fields.id];
                followingId = deleteFutureEditEvents[fields.followingID];
            }
            else {
                followingId = null;
            }
        } while (futureEvents.length === 1 && !isNullOrUndefined(deleteFutureEditEvents[fields.followingID]));
        return deleteFutureEditEventList;
    }
    getEditedOccurrences(deleteFutureEditEventList, startTime) {
        const fields = this.parent.eventFields;
        let deleteRecurrenceEventList = [];
        let delEditedEvents;
        for (const event of deleteFutureEditEventList) {
            let delEventQuery = new Predicate(fields.recurrenceID, 'equal', event[fields.id]).
                or(new Predicate(fields.recurrenceID, 'equal', event[fields.followingID]).
                and(new Predicate(fields.recurrenceID, 'notequal', undefined)).
                and(new Predicate(fields.recurrenceID, 'notequal', null)));
            if (this.parent.currentAction === 'EditFollowingEvents' || this.parent.currentAction === 'DeleteFollowingEvents') {
                delEventQuery = delEventQuery.and(new Predicate(fields.startTime, 'greaterthanorequal', startTime));
            }
            delEditedEvents = this.getFilterEventsList(this.parent.eventsData, delEventQuery);
            deleteRecurrenceEventList = deleteRecurrenceEventList.concat(delEditedEvents);
        }
        return deleteRecurrenceEventList;
    }
    getRenderedDates(dateRender) {
        let firstDate = 0;
        let lastDate = dateRender.length;
        let filteredDates;
        const maxDate = isNullOrUndefined(this.parent.maxDate) ? new Date(2099, 11, 31) : this.parent.maxDate;
        const minDate = isNullOrUndefined(this.parent.minDate) ? new Date(1900, 0, 1) : this.parent.minDate;
        if (dateRender[0] < minDate && dateRender[dateRender.length - 1] > maxDate) {
            for (let i = 0; i < dateRender.length; i++) {
                if (util.resetTime(dateRender[parseInt(i.toString(), 10)]).getTime() === util.resetTime(new Date(minDate)).getTime()) {
                    firstDate = i;
                }
                if (util.resetTime(dateRender[parseInt(i.toString(), 10)]).getTime() === util.resetTime(new Date(maxDate)).getTime()) {
                    lastDate = i;
                }
            }
            filteredDates = dateRender.filter((date) => date >= dateRender[parseInt(firstDate.toString(), 10)] && date <= dateRender[parseInt(lastDate.toString(), 10)]);
        }
        return filteredDates;
    }
    isValidEvent(eventObj, start, end, schedule) {
        const isHourRange = end.getTime() > schedule.startHour.getTime() && start.getTime() < schedule.endHour.getTime();
        const isSameRange = schedule.startHour.getTime() <= start.getTime() &&
            eventObj[this.parent.eventFields.startTime].getTime() >= schedule.startHour.getTime() &&
            eventObj[this.parent.eventFields.endTime].getTime() < schedule.endHour.getTime() && start.getTime() === end.getTime();
        return isHourRange || isSameRange;
    }
    allDayExpandScroll(dateHeader) {
        let indentHeight = 0;
        const headerRows = [].slice.call(this.parent.element.querySelectorAll('.' + cls.HEADER_ROW_CLASS));
        headerRows.forEach((element) => {
            const tdEle = [].slice.call(element.children);
            tdEle.forEach((ele) => { ele.style.top = indentHeight + 'px'; });
            indentHeight += element.offsetHeight;
        });
        indentHeight = dateHeader.offsetHeight - indentHeight;
        this.parent.element.querySelector('.' + cls.ALLDAY_CELLS_CLASS).style.height = (indentHeight / 12) + 'em';
        if (this.parent.uiStateValues.expand) {
            addClass([dateHeader], cls.ALLDAY_APPOINTMENT_SCROLL);
        }
        else {
            removeClass([dateHeader], cls.ALLDAY_APPOINTMENT_SCROLL);
        }
    }
    updateEventMinimumDuration(startEndHours, startTime, endTime) {
        if (startTime.getTime() < endTime.getTime() || (startTime.getTime() === endTime.getTime() &&
            (startEndHours.startHour.getTime() < endTime.getTime() && startEndHours.endHour.getTime() > startTime.getTime()) &&
            this.parent.currentView.indexOf('Timeline') === -1)) {
            const eventDuration = (util.getUniversalTime(endTime) - util.getUniversalTime(startTime)) / util.MS_PER_MINUTE;
            if (eventDuration < this.parent.eventSettings.minimumEventDuration) {
                const tempEnd = new Date(startTime);
                tempEnd.setMinutes(tempEnd.getMinutes() + this.parent.eventSettings.minimumEventDuration);
                endTime = tempEnd;
                if (endTime.getTime() > startEndHours.endHour.getTime()) {
                    const tempStart = new Date(startEndHours.endHour.getTime());
                    tempStart.setMinutes(tempStart.getMinutes() - this.parent.eventSettings.minimumEventDuration);
                    startTime = tempStart;
                    endTime = startEndHours.endHour;
                }
            }
        }
        return { startDate: startTime, endDate: endTime };
    }
    createEventWrapper(type = '', index = 0) {
        const tr = createElement('tr');
        const levels = this.parent.activeView.colLevels.slice(-1)[0];
        const className = this.parent.isReact && this.parent.activeViewOptions.eventTemplate ?
            ' ' + cls.APPOINTMENT_WRAPPER_HIDDEN_CLASS : '';
        for (let i = 0, len = levels.length; i < len; i++) {
            const col = levels[parseInt(i.toString(), 10)];
            const appointmentWrap = createElement('td', {
                className: (type === 'allDay') ? cls.ALLDAY_APPOINTMENT_WRAPPER_CLASS + className : (type === 'timeIndicator') ?
                    cls.TIMELINE_WRAPPER_CLASS : cls.DAY_WRAPPER_CLASS + className, attrs: { 'data-date': col.date.getTime().toString() }
            });
            if (!isNullOrUndefined(col.groupIndex)) {
                appointmentWrap.setAttribute('data-group-index', col.groupIndex.toString());
            }
            if (type === '') {
                const innerWrapper = createElement('div', {
                    id: cls.APPOINTMENT_WRAPPER_CLASS + '-' + index.toString(),
                    className: cls.APPOINTMENT_WRAPPER_CLASS
                });
                appointmentWrap.appendChild(innerWrapper);
            }
            tr.appendChild(appointmentWrap);
            index = index + 1;
        }
        return tr;
    }
    getPageCoordinates(e) {
        if (isNullOrUndefined(e)) {
            return e;
        }
        const eventArgs = e.event;
        return eventArgs && eventArgs.changedTouches ? eventArgs.changedTouches[0] : e.changedTouches ? e.changedTouches[0] :
            eventArgs || e;
    }
    renderSpannedIcon(element, spanEvent) {
        const iconElement = createElement('div', { className: cls.EVENT_INDICATOR_CLASS + ' ' + cls.ICON });
        if (spanEvent.isLeft) {
            const iconLeft = iconElement.cloneNode();
            addClass([iconLeft], cls.EVENT_ICON_LEFT_CLASS);
            prepend([iconLeft], element);
        }
        if (spanEvent.isRight) {
            const iconRight = iconElement.cloneNode();
            addClass([iconRight], cls.EVENT_ICON_RIGHT_CLASS);
            append([iconRight], element);
        }
        if (spanEvent.isTop) {
            const iconTop = iconElement.cloneNode();
            addClass([iconTop], cls.EVENT_ICON_UP_CLASS);
            prepend([iconTop], element);
        }
        if (spanEvent.isBottom) {
            const iconBottom = iconElement.cloneNode();
            addClass([iconBottom], cls.EVENT_ICON_DOWN_CLASS);
            append([iconBottom], element);
        }
    }
    addCellHeight(selector, eventHeight, eventGap, headerHeight, indHeight, isScrollUpdate = true) {
        if (this.parent.activeViewOptions.maxEventsPerRow && !this.parent.rowAutoHeight) {
            const rows = [].slice.call(this.parent.element.querySelectorAll(selector));
            const weekNumberRows = this.parent.showWeekNumber
                ? [].slice.call(this.parent.element.querySelectorAll('.' + cls.WEEK_NUMBER_WRAPPER_CLASS + ' tbody tr'))
                : [];
            for (const row of rows) {
                const height = (this.parent.activeViewOptions.maxEventsPerRow *
                    ((eventHeight + (this.parent.currentView === 'Month' ? eventGap : 2)))) + headerHeight + indHeight;
                if (weekNumberRows.length > 0) {
                    setStyleAttribute(weekNumberRows[rows.indexOf(row)].firstElementChild, { 'height': height + 'px' });
                }
                setStyleAttribute(row.firstElementChild, { 'height': height + 'px' });
            }
            if (!this.parent.enablePersistence && !this.parent.activeViewOptions.allowVirtualScrolling && isScrollUpdate) {
                this.parent.notify(event.contentReady, {});
            }
        }
    }
    unWireEvents() {
        const appElements = [].slice.call(this.parent.element.querySelectorAll('.' + cls.APPOINTMENT_CLASS));
        for (const element of appElements) {
            EventHandler.clearEvents(element);
        }
    }
    destroy() {
        this.unWireEvents();
        this.parent = null;
    }
}
